import React from 'react';
import classNames from 'classnames';

// Styles
import './styles.scss';

interface Props {
    left: React.ReactNode | string;
    right: React.ReactNode | string;
    noMargin?: boolean;
    expandLeft?: boolean;
}

export class AlignLeftAndRightComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | string {
        const { left, right, noMargin, expandLeft } = this.props;
        return (
            <div className="align-left-and-right">
                <div
                    className={classNames('align-left', {
                        'no-margin': noMargin,
                        'expand-left': expandLeft
                    })}
                >
                    {left}
                </div>
                <div className="align-right">{right}</div>
            </div>
        );
    }
}

export default AlignLeftAndRightComponent;
